import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getLookupsPhenologicalState = async () => {
	const { data } = await axios.get(`${API}/app/maintainer/phenological-state/lookups`);
	return data;
};

export const getPhenologicalState = async (filters) => {
	const { data } = await axios.get(`${API}/app/maintainer/phenological-state/`, { params: filters });
	return data;
};

export const getPhenologicalStateById = async (filters, element_id) => {
	const { data } = await axios.get(`${API}/app/maintainer/phenological-state/${element_id}`, { params: filters });
	return data;
};

export const savePhenologicalState = async (params) => {
	let URL = `${API}/app/maintainer/phenological-state/`;

	if (params.id != null) {
		const { data } = await axios.patch(URL + params.id, params);
		return data;
	}

	const { data } = await axios.post(URL, params);
	return data;
};

export const deletePhenologicalState = async (params) => {
	const { data } = await axios.delete(`${API}/app/maintainer/phenological-state/${params.selected}`);
	return data;
};
